export const FETCH_NOTIFICATIONS_EVENT = 'fetchnotifications';
